// extracted by mini-css-extract-plugin
module.exports = {"loading":"Spinner_loading__4WxZC","l":"Spinner_l__vAe_J","spinner-model":"Spinner_spinner-model__37IIl"};